import { API_BASE_URL } from "@/config/apiBase";
import { isFirebaseWebConfigured } from "@/config/firebaseAuth";
import { vueEnv } from "@/config/vueEnv";
import { ensureWebConfigLoaded } from "@/config/loadWebConfig";

let adminCheckPromise = null;

export const GOOGLE_SETUP_ERROR =
  "Google sign-in is not configured. Set GOOGLE_CLIENT_ID in backend/.env " +
  "(and VUE_APP_GOOGLE_CLIENT_ID in testOpsHub/.env for local dev). " +
  "Copy Web client ID from Firebase → Authentication → Google, then restart backend and yarn serve.";

async function fetchFirebaseAdminConfigured() {
  try {
    const res = await fetch(`${API_BASE_URL || ""}/api/config/web`, {
      credentials: "same-origin",
    });
    if (!res.ok) return false;
    const data = await res.json();
    return !!data.firebaseAdminConfigured;
  } catch (_err) {
    return false;
  }
}

/** Ask backend whether Firebase Admin can verify tokens (no private key → use GIS). */
export async function resolveGoogleAuthMode() {
  await ensureWebConfigLoaded();

  if (!adminCheckPromise) {
    adminCheckPromise = fetchFirebaseAdminConfigured();
  }
  const firebaseAdminReady = await adminCheckPromise;
  const useFirebase = isFirebaseWebConfigured() && firebaseAdminReady;

  return {
    useFirebase,
    googleClientId: vueEnv("VUE_APP_GOOGLE_CLIENT_ID"),
  };
}
